const plainObjectPrototypes = new Set([Array.prototype, Object.prototype]);
/**
 * Работает как {@link JSON.stringify}, но заменяет циркулярные ссылки на '[Circular]'
 * @param data любой объект
 * @param replacer функция замены значений при сериализации
 * @param space настройка отступов при форматировании
 * @returns JSON-строку
 */
export function safeJsonStringify(data, replacer = (k, v) => v, space) {
    const placeholder = '[Circular]';
    const processedObjects = new Array();
    function moveToCurrentParent(currentParent) {
        // Удаляем всех родителей, вплоть до текущего родителя
        while (processedObjects.length && processedObjects.at(-1) !== currentParent) {
            processedObjects.pop();
        }
        if (processedObjects.length === 0) {
            processedObjects.push(currentParent);
        }
    }
    return JSON.stringify(data, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            // Сериализуем только простые объекты, списки и объекты с реализованным методом toJSON
            if (!plainObjectPrototypes.has(Object.getPrototypeOf(value)) && !('toJSON' in value)) {
                return;
            }
            // this является родителем текущей пары key/value
            moveToCurrentParent(this);
            if (processedObjects.includes(value)) {
                return replacer(key, placeholder);
            }
            processedObjects.push(value);
        }
        return replacer(key, value);
    }, space);
}
